/* eslint-disable no-restricted-imports */
import { useSelector } from "react-redux";
import { DeprecatedReduxState } from "./types";

export function useIsAdmin() {
  const admin = useSelector((state: DeprecatedReduxState) => state.session.admin);

  return Boolean(admin);
}
